<template>
	<v-flex>
		<v-menu
			v-model="menu"
			:close-on-content-click="false"
			:disabled="readonly"
			:nudge-right="40"
			full-width
			lazy
			min-width="290px"
			offset-y
			transition="scale-transition"
		>
			<template #activator="{ on }">
				<v-text-field
					v-if="!isSimple"
					v-model="valueFormatted"
					v-on="on"
					:clearable="isClearable"
					:error-messages="$props.error"
					:label="dateLabel"
					:placeholder="' '"
					readonly
				></v-text-field>
				<v-text-field
					v-if="isSimple"
					v-model="valueFormatted"
					v-on="on"
					:clearable="isClearable"
					:placeholder="' '"
					class="simple"
					hide-details
					readonly
				></v-text-field>
			</template>
			<v-date-picker
				v-model="selectedValue" :first-day-of-week="1" :locale="'hr'" :readonly="readonly"
				@input="menu = false"></v-date-picker>
		</v-menu>
	</v-flex>
</template>

<script>
export default {
	name: "DatePicker",
	props: ['readonly', 'value', 'dateLabel', 'error', 'simple', 'clearable'],
	data() {
		return {
			menu: false,
			valueFormatted: null,
			selectedValue: this.$props.value
		}
	},
	computed: {
		isSimple() {
			return (typeof this.$props.simple !== 'undefined');
		},
		isClearable() {
			return (typeof this.$props.clearable !== 'undefined');
		}
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal != oldVal) {
				if (newVal != null) {
					if (this.selectedValue != null) {
						if (this.selectedValue.value != newVal) {
							this.setValue(newVal);
						}
					} else {
						this.setValue(newVal);
					}
				} else {
					this.selectedValue = null;
				}
			}
		},
		selectedValue: function (val) {
			this.valueFormatted = this.formatDate(this.selectedValue);
			if (val != null) {
				if (val != this.$props.value) {
					this.$nextTick(() => {
						this.$emit('input', val);
					})
				}
			} else {
				this.$nextTick(() => {
					this.$emit('input', null);
				})
			}
			this.$nextTick(() => {
				this.$emit('changes', null);
			})
		},
		valueFormatted: function (val) {
			if (val == null) {
				this.selectedValue = null;
			}
		}
	},
	methods: {
		parseDate(date) {
			if (!date) return null
			const [month, day, year] = date.split('.')
			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
		},
		formatDate(date) {
			if (!date) return null
			const [year, month, day] = date.split('-')
			return `${parseInt(day)}.${parseInt(month)}.${year}.`
		},
		setValue(newVal) {
			this.selectedValue = newVal;
		}
	},
	mounted() {
		this.setValue(this.$props.value);
		this.valueFormatted = this.formatDate(this.selectedValue);
	}
}
</script>

<style scoped>
.simple {
	padding: 0px;
	margin: 0px;
}
</style>
